export const getPriceItem = (priceId) => ({ prices }) =>
prices.pricesList.find(({ id }) => id === priceId);